import { Schema as S } from "effect";

export const CommandEvent = S.Struct({
	id: S.String,
	name: S.String,
	timestamp: S.String,
	success: S.Boolean,
	details: S.String,
});
export type CommandEvent = typeof CommandEvent.Type;

/** `startedAt` is `None` while connecting; the countdown runs once the data channel opened. */
export const Session = S.Struct({
	id: S.String,
	startedAt: S.Option(S.Number),
});
export type Session = typeof Session.Type;

export const Model = S.Struct({
	page: S.Literal("AI"),
	session: S.Option(Session),
	/** Seconds left in the 5-minute session (v1 `timeRemaining`). */
	remaining: S.Number,
	error: S.Option(S.String),
	/** Newest first, capped at 50 (v1). */
	history: S.Array(CommandEvent),
	seq: S.Number,
});
export type Model = typeof Model.Type;

/** v1: hardcoded 5 minutes. */
export const SESSION_LIMIT_MS = 5 * 60 * 1000;
export const HISTORY_CAP = 50;
